import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';
import MainView from '../views/MainView.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'home',
        component: MainView,
    },
    {
        path: '/:lang?',
        name: 'homeWithLang',
        component: MainView,
    },
];

const router = new VueRouter({
    routes,
});

router.beforeEach((to, from, next) => {
    window.dataLayer = window.dataLayer || [];
    let language = to.params.lang;
    if (!language) {
        language = 'de';
    }
    store.dispatch('setSelectedLanguage', language);
    next();
});

export default router;
